// Operations-area shared utilities + design tokens.
import { formatCurrency } from "../../lib/api";

export const STATUS_STYLES = {
  NewLead:         { bg: "#F3F4F6", text: "#374151", label: "New lead" },
  UnderReview:     { bg: "#EFF6FF", text: "#1D4ED8", label: "Under review" },
  Approved:        { bg: "#DBEAFE", text: "#1E40AF", label: "Approved" },
  Funded:          { bg: "#DCFCE7", text: "#166534", label: "Funded" },
  Active:          { bg: "#DCFCE7", text: "#166534", label: "Active" },
  PendingSettlement: { bg: "#FEF3C7", text: "#D97706", label: "Pending settlement" },
  PayoffRequested: { bg: "#FEF3C7", text: "#D97706", label: "Payoff requested" },
  Settled:         { bg: "#F3F4F6", text: "#4B5563", label: "Settled" },
  Closed:          { bg: "#F3F4F6", text: "#4B5563", label: "Closed" },
  Declined:        { bg: "#FEE2E2", text: "#B91C1C", label: "Declined" },
};

export const AGING_STYLES = {
  "0_3_months":   { bg: "#F3F4F6", text: "#374151", label: "0–3 months" },
  "3_6_months":   { bg: "#FEF9C3", text: "#A16207", label: "3–6 months" },
  "6_12_months":  { bg: "#FEF3C7", text: "#B45309", label: "6–12 months" },
  "12_18_months": { bg: "#FFEDD5", text: "#C2410C", label: "12–18 months" },
  "18_plus_months": { bg: "#FEE2E2", text: "#B91C1C", label: "18+ months" },
  "settled":      { bg: "#F3F4F6", text: "#4B5563", label: "Settled" },
};

export const CHART_PALETTE = ["#0066FF", "#0A2540", "#60A5FA", "#93C5FD", "#BFDBFE", "#374151"];

export const ALL_STATUSES = ["NewLead", "UnderReview", "Approved", "Funded", "Active", "PendingSettlement", "PayoffRequested", "Settled", "Closed", "Declined"];

export const fmtMoney = (n) => formatCurrency(n);
export const fmtCompactMoney = (n) => {
  if (n == null) return "—";
  const abs = Math.abs(n);
  if (abs >= 1e6) return `$${(n / 1e6).toFixed(1)}M`;
  if (abs >= 1e3) return `$${(n / 1e3).toFixed(1)}k`;
  return `$${n.toFixed(0)}`;
};
export const fmtPct = (n, digits = 1) => (n == null ? "—" : `${(n * 100).toFixed(digits)}%`);
export const fmtNumber = (n) => new Intl.NumberFormat("en-US").format(n || 0);

// Status pill — reusable
export function StatusPill({ status, size = "sm" }) {
  const cfg = STATUS_STYLES[status] || STATUS_STYLES.NewLead;
  const sz = size === "lg" ? "px-2.5 py-1 text-xs" : "px-2 py-0.5 text-[11px]";
  return (
    <span
      className={`inline-flex items-center rounded-full font-medium border border-transparent ${sz}`}
      style={{ background: cfg.bg, color: cfg.text }}
      data-testid={`status-pill-${status}`}
    >{cfg.label}</span>
  );
}

export function AgingChip({ bucket }) {
  const cfg = AGING_STYLES[bucket] || AGING_STYLES["0_3_months"];
  return (
    <span
      className="inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium"
      style={{ background: cfg.bg, color: cfg.text }}
      data-testid={`aging-chip-${bucket}`}
    >{cfg.label}</span>
  );
}
